<template>
  <div class="h-100">
    <cc-sidebar ref="sidebarRightFilter" id="sidebar-right-filter"
                title="Điều kiện tìm kiếm">
      <template slot="body">
        <filter-panel ref="filterPanel"></filter-panel>
      </template>
      <template slot="footer">
        <div class="align-items-center p-3">
          <CRow>
            <CCol :col="{size: 10, offset: 1}">
              <CRow>
                <CCol col="6">
                  <CButton block color="danger" size="sm" @click="resetCondition">Xóa điều kiện</CButton>
                </CCol>
                <CCol col="6">
                  <CButton block color="success" size="sm" @click="filterListWithCondition">Tìm kiếm</CButton>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </div>
      </template>
    </cc-sidebar>
    <CRow class="h-100">
      <CCol class="h-100 px-2">
        <cc-modal id="cc-modal-create-or-update"
                  :title="formData.type === 'update' ? 'Cập nhật cài đặt' : 'Thêm mới cài đặt'"
                  @onShowModal="onShowModal">
          <template slot="body">
            <validation-observer tag="form" ref="form" onsubmit="return false">
              <CRow class="mb-3">
                <CCol>
                  <label for="input-setting-product-id">
                    Mã cài đặt
                    <span class="text-star-validate-01">*</span>
                  </label>
                  <validation-provider name="Mã cài đặt" rules="required" v-slot="{valid, errors}">
                    <b-form-input id="input-setting-product-id" v-model="formData.product_id"
                                  placeholder="Nhập tài nguyên cài đặt..."
                                  trim aria-describedby="input-settingName"
                                  :state="!valid && errors[0] ? valid : null"
                                  @keydown.enter.prevent="keydownEnterModal">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-settingName">{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow class="mb-3">
                <CCol>
                  <label for="input-setting-name">
                    Tên cài đặt
                    <span class="text-star-validate-01">*</span>
                  </label>
                  <validation-provider name="Tài nguyên" rules="required" v-slot="{valid, errors}">
                    <b-form-input id="input-setting-name" v-model="formData.name"
                                  placeholder="Nhập tài nguyên cài đặt..."
                                  trim aria-describedby="input-settingName"
                                  :state="!valid && errors[0] ? valid : null"
                                  @keydown.enter.prevent="keydownEnterModal">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-settingName">{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <label for="input-setting-value">
                    Dakland
                    <span class="text-star-validate-01">*</span>
                  </label>
                  <validation-provider name="Giá trị cài đặt"
                                       rules="required|numeric|min_value:0"
                                       v-slot="{valid, errors}">
                    <number-input id="input-setting-value" v-model="formData.value"
                                  placeholder="Nhập Dakland cài đặt..."
                                  trim aria-describedby="input-settingValue"
                                  :state="!valid && errors[0] ? valid : null"
                                  @onKeydownNumberInput="keydownEnterModal">
                    </number-input>
                    <b-form-invalid-feedback id="input-settingValue">{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <label for="input-setting-value">
                    Hạn sử dụng
                    <span class="text-star-validate-01">*</span>
                  </label>
                  <validation-provider name="Hạn sử dụng cài đặt"
                                       rules="required|numeric|min_value:0"
                                       v-slot="{valid, errors}">
                    <number-input id="input-setting-day-reward" v-model="formData.day_reward"
                                  placeholder="Nhập Hạn sử dụng cài đặt..."
                                  trim aria-describedby="input-settingValue"
                                  :state="!valid && errors[0] ? valid : null"
                                  @onKeydownNumberInput="keydownEnterModal">
                    </number-input>
                    <b-form-invalid-feedback id="input-settingValue">{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </CCol>
              </CRow>
            </validation-observer>
          </template>
          <template slot="footer">
            <div class="w-100 text-right">
              <CButton v-if="formData.type === 'update'" color="info" class="px-3 mr-2" @click="onUpdateSetting">
                Cập nhật
              </CButton>
              <CButton v-else color="success" class="px-3 mr-2" @click="onCreateSetting">
                Thêm mới
              </CButton>
              <CButton color="secondary" class="px-3" @click="closeModal">Đóng</CButton>
            </div>
          </template>
        </cc-modal>
        <cc-ve-table ref="ccVeTable" namespace="setting" :columns="columns" :scroll-width="1000"
                     :is-column-expand="false" :is-show-pagination="false" :cell-style-option="cellStyleOption"
                     :event-custom-option="eventCustomOption" @itemSelectedLength="getItemSelectedLength">
          <template slot="cCardHeader">
            <CRow>
              <CCol col="7">
                <h4 class="text-uppercase mb-0 mt-1">Cài đặt hệ thống</h4>
              </CCol>
              <CCol col="5" class="float-right">
                <CRow>
                  <CCol :col="{size: 8, offset: 4}">
                    <CRow>
                      <CCol col="5">
                        <CButton block color="danger"
                                 :disabled="!itemSelectedLength"
                                 @click="deleteSelectedTable">
                          Xóa
                        </CButton>
                      </CCol>
                      <CCol col="5">
                        <CButton block color="success"
                                 @click="openModalCreateOrUpdate('cc-modal-create-or-update', null)">
                          Thêm mới
                        </CButton>
                      </CCol>
                      <CCol col="2" class="text-center align-self-center">
                        <CLink href="#" v-b-toggle.sidebar-right-filter>
                          <CIcon name="cil-filter" height="20"/>
                        </CLink>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </template>
        </cc-ve-table>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CcSidebar from '@/components/common/CcSidebar'
import FilterPanel from '@/components/setting/FilterPanel'
import CcVeTable from '@/components/common/tableList/CcVeTable'
import CcModal from '@/components/common/CcModal'
import NumberInput from '@/components/common/NumberInput'
import {mapActions} from 'vuex'
import {format} from '@/mixins/format'
import * as _ from 'lodash'
import {SHOW_TOAST_2} from '@/common/lib'

export default {
  name: "List",
  components: {
    NumberInput,
    CcModal,
    CcVeTable,
    CcSidebar,
    FilterPanel
  },
  mixins: [
    format
  ],
  data() {
    return {
      itemSelectedLength: 0,
      formData: {
        type: '',
        name: '',
        product_id: '',
        day_reward: 0,
        value: 0,
      },
      columns: [
        {
          title: 'Thông tin',
          children: [
            {
              field: 'product_id',
              key: 'product_id',
              title: 'Mã cài đặt',
              align: 'left',
              width: 100,
              renderBodyCell: ({row, column}) => {
                return (
                  <CLink class="font-weight-bold"
                         onclick={() => this.openModalCreateOrUpdate('cc-modal-create-or-update', row)}>
                    {row[column.field]}
                  </CLink>
                )
              }
            },
            {
              field: 'name',
              key: 'name',
              title: 'Tài nguyên',
              align: 'left',
              width: 200,
              renderBodyCell: ({row, column}) => {
                return <strong>{row[column.field]}</strong>
              }
            },
            {
              field: 'value',
              key: 'value',
              title: 'Dakland',
              align: 'center',
              width: 100,
              renderBodyCell: ({row, column}) => {
                return <strong>{this.fNumber(row[column.field])} Dakland</strong>
              }
            },
            {
              field: 'day_reward',
              key: 'day_reward',
              title: 'Hạn sử dụng',
              align: 'center',
              width: 80,
              renderBodyCell: ({row, column}) => {
                return <strong>{this.fNumber(row[column.field])} ngày</strong>
              }
            },
          ]
        }
      ],
      cellStyleOption: {
        bodyCellClass: ({column}) => {
          if (['checkbox'].includes(column.type) || column.field === 'name') {
            return 'cursor-pointer'
          }
        }
      },
      eventCustomOption: {
        bodyCellEvents: ({row, column}) => {
          return {
            click: () => {
              if (column.field !== 'name') {
                const currentRowKey = row['id']
                this.$refs.ccVeTable.changeSelectedRowKeysByRowClick(currentRowKey)
              } else {
                this.openModalCreateOrUpdate('cc-modal-create-or-update', row)
              }
            }
          }
        }
      }
    }
  },
  async mounted() {
    if (this.$refs.ccVeTable) {
      await this.getDataTable()
      this.$refs.ccVeTable.showToastGetDataList('item setting')
    }
  },
  methods: {
    ...mapActions('setting', ['getDataList', 'createSetting', 'updateSetting', 'deleteSetting']),
    async getDataTable() {
      this.$refs.ccVeTable && this.$refs.ccVeTable.loadingInstance && this.$refs.ccVeTable.loadingInstance.show()
      let _param = {
        filter: {}
      }
      const _filterMap = this.$refs.filterPanel.filterMap
      _.merge(_param['filter'], _filterMap)
      await this.getDataList(_param)
      this.$refs.ccVeTable && this.$refs.ccVeTable.loadingInstance && this.$refs.ccVeTable.loadingInstance.close()
    },
    async deleteSelectedTable() {
      const _countItemDeleted = this.$refs.ccVeTable.dataTableSelected.length
      const confirm = window.confirm(`Bạn có chắc chắn muốn xóa ${_countItemDeleted} item setting?`)
      if (confirm) {
        if (this.$refs.ccVeTable.dataTableSelected && this.$refs.ccVeTable.dataTableSelected.length) {
          const res = await this.deleteSetting(this.$refs.ccVeTable.dataTableSelected)
          if (res && res === 'deleteSettingSuccess') {
            this.$refs.ccVeTable.unselectedAll()
            await this.getDataTable()
            SHOW_TOAST_2('success', 'Xóa cài đặt thành công.')
          } else {
            SHOW_TOAST_2('error', 'Không thể xóa cài đặt. Vui lòng thử lại!')
          }
        }
      }
    },
    async onCreateSetting() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        const params = _.merge({}, this.formData)
        delete params.type

        const res = await this.createSetting(params)
        if (res && res === 'createSettingSuccess') {
          this.closeModal()
          await this.$refs.filterPanel.resetCondition()
          await this.getDataTable()
          SHOW_TOAST_2('success', 'Thêm mới cài đặt thành công.')
        } else {
          SHOW_TOAST_2('error', 'Không thể thêm mới cài đặt. Vui lòng thử lại!')
        }
      }
    },
    async onUpdateSetting() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        const params = _.merge({}, this.formData)
        delete params.type

        const res = await this.updateSetting(params)
        if (res && res === 'updateSettingSuccess') {
          this.closeModal()
          await this.getDataTable()
          SHOW_TOAST_2('success', 'Cập nhật cài đặt thành công.')
        } else {
          SHOW_TOAST_2('error', 'Không thể cập nhật cài đặt. Vui lòng thử lại!')
        }
      }
    },
    resetCondition() {
      this.$refs.filterPanel.resetCondition()
    },
    async filterListWithCondition() {
      this.$refs.sidebarRightFilter.$refs.ccSidebar.hide()
      await this.getDataTable()
      this.$refs.ccVeTable.showToastGetDataList('item setting')
    },
    getItemSelectedLength(value) {
      this.itemSelectedLength = value
    },
    openModalCreateOrUpdate(id, rowSelected) {
      if (rowSelected) {
        _.merge(this.formData, rowSelected)
      } else {
        delete this.formData.id
        this.formData.name = ''
        this.formData.value = null
      }
      this.$bvModal.show(id)
    },
    onShowModal() {
      if (this.formData.id) {
        this.formData.type = 'update'
      } else {
        this.formData.type = 'create'
      }
    },
    closeModal() {
      this.$bvModal.hide('cc-modal-create-or-update')
    },
    keydownEnterModal() {
      if (this.formData.type === 'update') {
        this.onUpdateSetting()
      } else {
        this.onCreateSetting()
      }
    }
  }
}
</script>

<style scoped>

</style>
